export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImagenUsuario.vue?vue&type=template&id=135b2f7c&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/ImagenUsuario.vue?vue&type=template&id=135b2f7c&scoped=true&
// module id = 624
// module chunks = 3